export const selectWorkshops = (state) => state.workshops;

export const selectWorkshopList = (state) => state.workshops.list;
export const selectWorkshopListLoading = (state) => state.workshops.loading;
export const selectWorkshopListLoadingCount = (state) => state.workshops.loadingCount;
export const selectWorkshopListError = (state) => state.workshops.error;
export const selectWorkshopFilters = (state) => state.workshops.filters;